<template>
  <button
    class="ThumbButton"
    type="button"
  >
    <Icon
      :name="iconName"
    />
    <slot />
  </button>
</template>

<script lang="ts" setup>
import { IconName } from "./Icon.types";
import Icon from "./Icon.vue";

defineProps<{
  iconName: keyof typeof IconName,
}>();
</script>

<style lang="scss" scoped>
.ThumbButton {
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;

  border: solid 2px var(--themeColorNeutral900);
  border-radius: 50%;
  background-color: var(--themeColorSecondary);
  color: var(--themeColorSecondaryForeground);
}
</style>
